import React, { useState } from "react";
import { useAuthHeader } from "react-auth-kit";
import { Link, useNavigate } from "react-router-dom";
import { IoChevronBackSharp } from "react-icons/io5";
import { BsSaveFill } from "react-icons/bs";
import { toast } from "react-toastify";
import ArticleEditSection from "../../components/Article/ArticleEditSection";

function CreateArticle() {
  const authHeader = useAuthHeader();
  const authHeaderValue = authHeader();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [article, setArticle] = useState({
    title: "",
    text: "",
    image: "",
    countryCode: "",
    isVisible: true,
    isPrivate: false,
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URI}/v1/admin/articles`,
        {
          method: "POST",
          body: JSON.stringify({
            ...article,
            countryCode: article.countryCode.value,
          }),
          headers: {
            Authorization: authHeaderValue,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.ok) {
        const responseData = await response.json();
        toast.success("Article has been created");
        navigate(`/articles/${responseData.id}`);
      } else {
        toast.error("Couldn't create article: " + response.status);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto">
      <div className="flex mb-6 justify-between items-center">
        <div className="flex items-center">
          <Link
            to={"/articles"}
            className="text-black mr-2 flex items-center justify-center gap-1 duration-300 hover:bg-gray-300 rounded-lg text-sm p-1"
          >
            <IoChevronBackSharp />
            BACK
          </Link>
          <div className="border-l border-gray-500 pl-4 flex items-center font-bold text-lg gap-1">
            <span>CREATE ARTICLE</span>
          </div>
        </div>
        <div className="flex items-center">
          <button
            form="article-create-form"
            type="submit"
            disabled={isSubmitting}
            className={`edit-btn`}
          >
            <BsSaveFill />
            CREATE
          </button>
        </div>
      </div>
      <div className="bg-white p-8 pb-12 rounded-md shadow-md">
        <form id="article-create-form" onSubmit={handleSubmit}>
          <ArticleEditSection article={article} setArticle={setArticle} />
        </form>
      </div>
    </div>
  );
}

export default CreateArticle;
